export default function removeSubstring(str: string, character: string) {
  const regex = new RegExp(`\\${character}`, 'gi'); // global replace, case insensitive (the double backslash is necessary to escape potential special characters like a period)
  return str.replace(regex, '');
}
